export const NEW_APP_VERSION_AVAILABLE = 'NEW_APP_VERSION_AVAILABLE'
export const UPDATE_APP_MESSAGE_CLOSED = 'UPDATE_APP_MESSAGE_CLOSED'
